class ShapeHomelandGallery extends HTMLElement {
  /** @type {HTMLElement[]} */
  #items = [];

  /** @type {number} */
  #index = 0;

  /** @type {(event: KeyboardEvent) => void} */
  #onDocKeyDown = (event) => {
    if (this.#items.length <= 1) return;
    if (this.#isFormFocused()) return;
    if (document.activeElement !== this && !this.contains(document.activeElement) && !this.matches(':hover')) {
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.#go(-1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.#go(1);
    }
  };

  /** @type {number} */
  #touchStartX = 0;

  connectedCallback() {
    this.#items = [...this.querySelectorAll('.shape-homeland-gallery__item')];
    if (this.#items.length <= 1) return;

    const viewport = this.querySelector('.shape-homeland-gallery__viewport');

    this.querySelector('.shape-homeland-gallery__btn--prev')?.addEventListener('click', (event) => {
      event.stopPropagation();
      this.#go(-1);
    });
    this.querySelector('.shape-homeland-gallery__btn--next')?.addEventListener('click', (event) => {
      event.stopPropagation();
      this.#go(1);
    });
    this.addEventListener('keydown', this.#onKeyDown);
    viewport?.addEventListener('click', () => this.focus());
    viewport?.addEventListener(
      'touchstart',
      (event) => {
        this.#touchStartX = event.changedTouches[0]?.screenX ?? 0;
      },
      { passive: true }
    );
    viewport?.addEventListener(
      'touchend',
      (event) => {
        const touchEndX = event.changedTouches[0]?.screenX ?? 0;
        const delta = touchEndX - this.#touchStartX;
        if (Math.abs(delta) < 48) return;
        this.#go(delta < 0 ? 1 : -1);
      },
      { passive: true }
    );
    document.addEventListener('keydown', this.#onDocKeyDown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.#onDocKeyDown);
  }

  /** @param {KeyboardEvent} event */
  #onKeyDown = (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.#go(-1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.#go(1);
    }
  };

  #isFormFocused() {
    const tag = document.activeElement?.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
  }

  /** @param {number} delta */
  #go(delta) {
    const count = this.#items.length;
    this.#index = (this.#index + delta + count) % count;

    this.#items.forEach((item, index) => {
      const active = index === this.#index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    const counter = this.querySelector('.shape-homeland-gallery__counter');
    if (counter) counter.textContent = `${this.#index + 1} / ${count}`;
  }
}

if (!customElements.get('shape-homeland-gallery')) {
  customElements.define('shape-homeland-gallery', ShapeHomelandGallery);
}
